import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
} from '../orgWorkspaceTour/orgWorkspaceTourSteps';

export { FOC_REQUIRED_DISPOSITION, IOC_CARRYOVER_DISPOSITION };

export const POST_FOC_DISPOSITION =
  'Post-FOC / Not Authorized Without Government Decision';

export type FocAiTourStepDef = {
  id: string;
  requirementId?: string;
  title: string;
  disposition?: string;
  description: string;
  bullets?: string[];
  tour?: string;
  /**
   * How long to wait for the target after preparing the step, when it needs a
   * page to load.
   */
  waitMs?: number;
};

export type RequirementInput = Omit<
  FocAiTourStepDef,
  'title' | 'requirementId'
> & {
  requirementId: string;
  name: string;
};

export function requirement({
  requirementId,
  name,
  ...rest
}: RequirementInput): FocAiTourStepDef {
  return {
    ...rest,
    requirementId,
    title: `${requirementId} — ${name}`,
  };
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function focAiTourPopoverHtml(
  step: Pick<FocAiTourStepDef, 'disposition' | 'description' | 'bullets'>
): string {
  const body = `<p>${escapeHtml(step.description)}</p>`;
  const bullets = step.bullets?.length
    ? `<ul>${step.bullets
        .map((bullet) => `<li>${escapeHtml(bullet)}</li>`)
        .join('')}</ul>`
    : '';
  const content = `${body}${bullets}`;
  if (!step.disposition) return content;
  return `<p><strong>Disposition:</strong> ${escapeHtml(step.disposition)}</p>${content}`;
}
